var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userPermissions.indexOf("ecp_team")>-1)?_c('div',{staticClass:"ecp-performance"},[_c('el-tabs',{staticClass:"performance-tab",attrs:{"tab-position":_vm.tabPosition}},[_c('TeamView')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }